import { render, staticRenderFns } from "./AvailableDays.vue?vue&type=template&id=45de9f94&scoped=true&"
import script from "./AvailableDays.vue?vue&type=script&lang=js&"
export * from "./AvailableDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45de9f94",
  null
  
)

export default component.exports